import { useTranslation } from "react-i18next";

import AllArticlesPanel from "../../articles/panels/AllArticlesPanel";

import { Container } from "components/ui-kit/styled-templates";

import useBodyBackground from "hooks/useBodyBackground";

const ArticlesDashboardPage = () => {
    const { t } = useTranslation();

    useBodyBackground("white");

    // @ts-ignore

    return (
        <Container extra="padding-top: 10px; align-items: flex-start;">
            <h2>{t("v07oslfmtx")}</h2>
            <AllArticlesPanel />
        </Container>
    );
};

export default ArticlesDashboardPage;
